import { ModuleTypes } from 'dashboard/apps/DashboardLayoutEditor/constants';
import { ComputedProperty } from 'dashboard/lib/case-layouts/computed-properties';
import { BaseModule } from 'dashboard/lib/module';

export interface ModuleInsightsSummary extends BaseModule {
  type: ModuleTypes.InsightsSummary;
  insights: Insight[];
  label: string;
}

export interface Insight {
  label: string;
  states: InsightState[];
}

export interface InsightState {
  icon: InsightSummaryIcons;
  color: string;
  'display-value': ComputedProperty;
  condition: ComputedProperty;
}

export enum InsightSummaryIcons {
  CHECK = 'check',
  ALERT = 'alert',
}
